import { computed, Signal } from '@angular/core';
import { select } from '@ngxs/store';
import { CodState } from '../../../state/cod.state';
import { FinancialAdjustment, FinancialAdjustmentNone } from '@cod-monorepo/interfaces';

export class BaseInternationalStep {
    public wasFiledWithin40Days: Signal<boolean | null> = select(CodState.wasFiledWithin40Days);

    public financialAdjustments = computed(() =>
        this.wasFiledWithin40Days() !== false ? FinancialAdjustment : FinancialAdjustmentNone
    );
}
